import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { AuthService } from "src/app/shared/services/auth.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalAsignarDepositarioComponent } from "src/app/components/core/layouts/modal-asignar-depositario/modal-asignar-depositario.component";
import { DepositarioProvisionalService } from "./depositario-provisional.service";
import { ModalConfirmarEliminarDepositarioComponent } from "src/app/components/core/layouts/modal-confirmar-eliminar-depositario/modal-confirmar-eliminar-depositario.component";

@Component({
  selector: "app-depositario-provisional",
  templateUrl: "./depositario-provisional.component.html",
  styleUrls: ["./depositario-provisional.component.scss"],
})
export class DepositarioProvisionalComponent implements OnInit {
  formDatos: FormGroup;
  informacionEstablecimiento: any;
  usuariosListaSend: Array<any> = [];
  cod_rnt: any;

  constructor(
    private depositarioProvisionalService: DepositarioProvisionalService,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.formulario();
  }

  formulario() {
    this.formDatos = this.formBuilder.group({
      codigo_rnt: [
        "",
        [Validators.required, ConfirmeValidators.numberValidator],
      ],
    });
  }

  getRnt(codigo_rnt: number) {
    this.depositarioProvisionalService
      .getConsultaPrestador({ codigo_rnt: codigo_rnt })
      .subscribe((resultado) => {
        this.cod_rnt = codigo_rnt;
        this.informacionEstablecimiento = resultado.data
          ? resultado.data[0]
          : null;
      });
  }

  openModalAsignarDepositario() {
    const modalRef = this.modalService.open(ModalAsignarDepositarioComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = true;
    modalRef.result
      .then((resultado) => {
        this.depositarioProvisionalService
          .asignarUsuarioDepositario({
            ...resultado,
            rnt_id: this.informacionEstablecimiento.rnt_id,
            solicitud_id: this.informacionEstablecimiento.solicitud_id,
            codigo_camara: this.informacionEstablecimiento.codigo_camara,
            correo_electronico_usuario_depositario: this
              .informacionEstablecimiento
              .correo_electronico_usuario_depositario,
            activo: true,
          })
          .subscribe((res) => {
            if (res.result) {
              this.getRnt(this.cod_rnt);
            }
          });
      })
      .catch((error) => {});
  }

  openModalEliminarDepositario() {
    const modalRef = this.modalService.open(ModalAsignarDepositarioComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = false;
    modalRef.result
      .then((resultado) => {
        const modalRes2 = this.modalService.open(
          ModalConfirmarEliminarDepositarioComponent,
          {
            centered: true,
            backdropClass: "light-blue-backdrop",
            backdrop: "static",
          }
        );
        modalRes2.result.then((resul) => {
          this.depositarioProvisionalService
            .eliminarUsuarioDepositario({
              ...resultado,
              usuario_id: this.informacionEstablecimiento
                .usuario_depositario_id,
              rnt_id: this.informacionEstablecimiento.rnt_id,
              solicitud_id: this.informacionEstablecimiento.solicitud_id,
              codigo_camara: this.informacionEstablecimiento.codigo_camara,
              correo_electronico_usuario_depositario: this
                .informacionEstablecimiento
                .correo_electronico_usuario_depositario,
              activo: true,
            })
            .subscribe((result) => {
              if (result.result) {
                this.getRnt(this.cod_rnt);
              }
            });
        });
      })
      .catch((error) => {});
  }
}
